import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';
import { AdvertisementService } from '../../service/advertisement.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-forumadd',
  templateUrl: './forumadd.component.html',
  styleUrls: ['./forumadd.component.css'],
  providers: [AdvertisementService,Globals]
})
export class ForumaddComponent implements OnInit {

  adv:any;
  section:string;
  limit:any;
  isError = false;
  msg: string;

  constructor(private advertisementService:AdvertisementService, private global: Globals) { 
    this.adv={ 
      image:'',
      title:'',
      link:''
     }
     //webassets/images/banner.jpg
  }

  ngOnInit() {
    this.getrandomadvlist();
  }

  getAdvImage(imagename){
    return this.global.advertisementImageUrl+imagename;
  }

  getrandomadvlist(){
    let obj = {};
    obj['section'] = 'Discussion-Main';
    obj['limit'] = 1;
    this.advertisementService.getrandomadvlist(obj).subscribe((data:any)=>{
      if(data.error==0){
        this.adv=data.results[0];
        //console.log( this.adv);
      }
    },
    (error: HttpErrorResponse)=>{
      this.isError = true;
      this.msg="internal server error!";
    })
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/forumadd/forumadd.component.ts